import { QueryClient } from "@tanstack/react-query";
import { ApiRequestError } from "../api/client";

/** Retry only what can succeed on a second try: network errors and 5xx. */
function shouldRetry(failures: number, error: unknown): boolean {
  if (failures >= 2) return false;
  if (error instanceof ApiRequestError) return error.status >= 500;
  return true;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 15_000, retry: shouldRetry, refetchOnWindowFocus: true },
      mutations: { retry: false },
    },
  });
}
